import { gql, useMutation } from '@apollo/client'

const useCreateBankAccountSetupIntent = (onCompleted = () => {}, onError = () => {}) => {
  const [createSetupIntent, { data, loading, error }] = useMutation(
    gql`
      mutation createBankAccountSetupIntent($userId: String!) {
        createBankAccountSetupIntent(userId: $userId)
      }
    `,
    {
      onCompleted: (data) => {
        if (data?.createBankAccountSetupIntent) {
          onCompleted(data.createBankAccountSetupIntent)
        } else {
          onError(new Error('No client secret returned'))
        }
      },
      onError,
    }
  )
  return [
    createSetupIntent,
    {
      clientSecret: data?.createBankAccountSetupIntent,
      loading,
      error,
    },
  ]
}

export default useCreateBankAccountSetupIntent